import { render, staticRenderFns } from "./host-product-item.vue?vue&type=template&id=734fc2fe&"
import script from "./host-product-item.vue?vue&type=script&lang=js&"
export * from "./host-product-item.vue?vue&type=script&lang=js&"
import style0 from "./host-product-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports